/* page */
/*--------------------------------------------------------------------------------*/
import { cfg } from '../../config';
import { confirm } from '../../mod/dialog';
import { openWinPopup } from '../../lib/utility';
import * as modBtn from '../../mod/built-in/button';
import { menu as setDropMenu } from '../../mod/drop';
const app = document.querySelector<HTMLElement>('#app');
export * from '../index';
export { hwLink } from '../../svchub/hwlink';
/*--------------------------------------------------------------------------------*/
export type PageParams = {
    uri?: string;
    size?: string;
    topbar?: string;
    sidebar?: string;
    template?: string;
};
/*--------------------------------------------------------------------------------*/
export const create = (params: PageParams): boolean => {
    if (!app) return false;
    const uri = params.uri ? params.uri : '';
    const size = params.size ? params.size : '';
    const topbar = params.topbar ? params.topbar : '';
    const sidebar = params.sidebar ? params.sidebar : '';
    const template = params.template ? params.template : '';
    // content
    const content = document.createElement('div');
    content.id = 'app-content';
    content.innerHTML = template;
    app.appendChild(content);
    // page init
    let newNav = false;
    if (size == 'full') {
        app.classList.add('full-page');
        navRemove();
    } else {
        app.classList.remove('full-page');
        if (!document.querySelector('#topbar')) {
            navCreate({ topbar: topbar, sidebar: sidebar });
            newNav = true;
        }
        navActive(uri);
    }
    return newNav;
};
/*--------------------------------------------------------------------------------*/
// ### navbar ###
/*--------------------------------------------------------------------------------*/
const navCreate = (params: { topbar: string; sidebar: string; }) => {
    // create topbar, sidebar
    const topbar = document.createElement('nav');
    const sidebar = document.createElement('nav');
    topbar.id = 'topbar';
    sidebar.id = 'sidebar';
    topbar.innerHTML = params.topbar;
    sidebar.innerHTML = params.sidebar;
    document.body.prepend(topbar, sidebar);
    // screen resize
    const setScreen = () => {
        const scWidth = window.innerWidth ? window.innerWidth : screen.width;
        const scHeight = window.innerHeight ? window.innerHeight : screen.height;
        const boxScreen = topbar.querySelector<HTMLElement>('#screen');
        if (boxScreen) boxScreen.innerHTML = `${scWidth}x${scHeight}`;
        // nav-menu action
        if (scWidth < 600) navMenu(true);
        else navMenu(false);
    };
    setScreen();
    window.addEventListener('resize', setScreen);
    // dropdown
    const dropUser = topbar.querySelector<HTMLElement>('#drop-user');
    if (dropUser) setDropMenu(dropUser);
    // logout
    const logout = () => {
        confirm('ยืนยัน..! การออกจากระบบ').then(res => {
            if (res) window.location.replace('/logout');
        });
    };
    const navLogout = document.querySelectorAll<HTMLElement>('#nav-logout');
    navLogout.forEach(el => el.onclick = logout);
    // hwlink
    navHwLink();
};
/*--------------------------------------------------------------------------------*/
const navRemove = () => {
    const topbar = document.querySelector<HTMLElement>('#topbar');
    const sidebar = document.querySelector<HTMLElement>('#sidebar');
    if (topbar) topbar.remove();
    if (sidebar) sidebar.remove();
};
/*--------------------------------------------------------------------------------*/
const navActive = (uri: string) => {
    if (uri.indexOf('#') > 0) {
        uri = uri.substring(0, uri.indexOf('#'));
    }
    clearNavActive();
    if (!uri) return;
    const sideBtn = document.querySelectorAll<HTMLButtonElement>('#sidebar button');
    sideBtn.forEach(btn => {
        const path = btn.getAttribute('href');
        if (!btn.disabled && uri == path) {
            btn.classList.add('active');
            // grp-btn
            if (btn.classList.contains('grp-btn')) {
                const menu = btn.parentNode?.querySelector<HTMLElement>('.submenu');
                const grpBtn = btn.parentNode?.querySelector<HTMLElement>('.grp-btn');
                if (menu && grpBtn) {
                    menu.style.maxHeight = '400px';
                    grpBtn.classList.add('bar');
                }
            }
            // sub-btn
            if (btn.classList.contains('sub-btn')) {
                const menu = btn.parentNode as HTMLElement;
                const grpBtn = menu.parentNode?.querySelector<HTMLElement>('.grp-btn');
                if (menu && grpBtn && menu.classList.contains('submenu')) {
                    menu.style.maxHeight = '400px';
                    grpBtn.classList.add('active');
                    grpBtn.classList.remove('bar');
                }
            }
        }
    });
};
const clearNavActive = () => {
    // sidebtn
    const sideBtn = document.querySelectorAll<HTMLButtonElement>('#sidebar button');
    sideBtn.forEach(btn => btn.classList.remove('active'));
    // submenu
    const subMenu = document.querySelectorAll<HTMLElement>('#sidebar .submenu');
    subMenu.forEach(elm => elm.style.maxHeight = '0');
};
/*--------------------------------------------------------------------------------*/
const navMenu = (state: boolean) => {
    const navMenu = document.querySelector<HTMLElement>('#topbar #nav-menu');
    const sidebar = document.querySelector<HTMLElement>('#sidebar');
    if (!navMenu || !sidebar) return;
    if (state) {
        navMenu.onclick = () => {
            const posLeft = sidebar.getBoundingClientRect().left;
            if (posLeft == 0) {
                sidebar.classList.remove('menu-in');
                sidebar.classList.add('menu-out');
            } else {
                sidebar.classList.remove('menu-out');
                sidebar.classList.add('menu-in');
            }
        };
    } else {
        navMenu.onclick = null;
        sidebar.classList.remove('menu-in');
        sidebar.classList.remove('menu-out');
    }
};
/*--------------------------------------------------------------------------------*/
export const clear = () => {
    const sidebar = document.querySelector<HTMLElement>('#sidebar');
    if (!sidebar) return;
    const scWidth = window.innerWidth ? window.innerWidth : screen.width;
    const posLeft = sidebar.getBoundingClientRect().left;
    if (scWidth < 600 && posLeft == 0) {
        sidebar.classList.remove('menu-in');
        sidebar.classList.add('menu-out');
    }
};
window.addEventListener('click', (e) => {
    if (!(<HTMLElement>e.target).matches('#nav-menu')) clear();
});
/*--------------------------------------------------------------------------------*/
const navHwLink = () => {
    const btnHwl = document.querySelector<HTMLButtonElement>('#nav-hwlink');
    if (!btnHwl) return;
    const agent = navigator.userAgent.toLowerCase();
    if (agent.indexOf('win') != -1) {
        btnHwl.style.display = 'block';
        btnHwl.onclick = () => {
            modBtn.loading(btnHwl, true);
            const ws = new WebSocket(cfg.hwl.HOST);
            ws.onerror = () => {
                download();
                done();
            };
            ws.onopen = () => {
                ws.close();
                openWinPopup('/hwlink', 'hwlink', 500, 485);
                done();
            };
            const done = () => {
                modBtn.loading(btnHwl, false);
            };
        };
    } else {
        btnHwl.style.display = 'none';
    }
    const download = () => {
        const url = cfg.hwl.FILE;
        const link = document.createElement('a');
        link.href = url;
        link.download = String(url.split('/').pop());
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
};
/*--------------------------------------------------------------------------------*/
const onlineStatus = () => {
    const boxTime = document.querySelector<HTMLElement>('#box-time');
    const svTime = document.querySelector<HTMLElement>('#box-time #sv-time');
    const svDate = document.querySelector<HTMLElement>('#box-time #sv-date');
    if (!boxTime || !svTime || !svDate) return;
    if (window.navigator.onLine) {
        boxTime.classList.remove('offline');
        svTime.innerHTML = '&nbsp;';
        svDate.innerHTML = '&nbsp;';
    } else {
        boxTime.classList.add('offline');
        svTime.innerHTML = 'network';
        svDate.innerHTML = 'OFFLINE';
    }
};
window.addEventListener('online', onlineStatus);
window.addEventListener('offline', onlineStatus);
/*--------------------------------------------------------------------------------*/
